import cs from '../../messages/dativeryCommon.cs.po';
import de from '../../messages/dativeryCommon.de.po';
import en from '../../messages/dativeryCommon.pot';
import fr from '../../messages/dativeryCommon.fr.po';
import hu from '../../messages/dativeryCommon.hu.po';
import sk from '../../messages/dativeryCommon.sk.po';
import it from '../../messages/dativeryCommon.it.po';
import {getLocale as getBasicLocale} from './basicLocales';

let allLocales = {
    /* list locales here */
    'cs': cs,
    'en': en,
    'de': de,
    'fr': fr,
    'hu': hu,
    'sk': sk,
    'it': it
};


let messages = allLocales[getBasicLocale()];
if (!messages) {
    messages = allLocales['en'];
}

export function getCommonMessages(lang) {
	if (lang && allLocales[lang]) {
		return allLocales[lang];
	}

    return messages;
}

export function getCommonMessagesForLocale(locale) {
    return allLocales[locale];
}
